export const DEFAULT_BASE_URL = 'https://api.kentozo.xyz';
/**
 * Build a postback URL for one (platform, event) pair.
 *
 * Parameter order is fixed and matches every existing surface: `brand`, then
 * `event`, then the platform's own params in the order declared on the
 * contract, then `source` last if provided. This order is asserted by the
 * equivalence test — do not reorder without re-checking it against all four
 * surfaces, because a reordered-but-otherwise-identical query string is still
 * a byte-for-byte different string that a naive diff (or a partner panel doing
 * exact-string comparisons) would treat as changed.
 */
export function generatePostbackLink(contract, event, opts) {
    const template = contract.events.find((e) => e.event === event);
    if (!template) {
        throw new Error(`Platform "${contract.id}" has no template for event "${event}"`);
    }
    const base = (opts.baseUrl ?? DEFAULT_BASE_URL).replace(/\/+$/, '');
    const brand = opts.brand || '{brand}';
    // `brand_id` leads when present, matching docs/BRAND-ID-AND-MCP.md, and is simply absent
    // otherwise — so every link built without it is unchanged, down to the byte.
    const parts = [];
    if (opts.brandId)
        parts.push(`brand_id=${opts.brandId}`);
    parts.push(`brand=${brand}`, `event=${template.eventValue}`);
    for (const param of template.params) {
        parts.push(`${param.ourParam}=${param.macro}`);
    }
    if (opts.source) {
        parts.push(`source=${opts.source}`);
    }
    return `${base}/postbacks/${contract.route}?${parts.join('&')}`;
}
/** Generate links for every event a contract supports, keyed by normalized event name. */
export function generateAllLinks(contract, opts) {
    const result = {};
    for (const template of contract.events) {
        result[template.event] = generatePostbackLink(contract, template.event, opts);
    }
    return result;
}
//# sourceMappingURL=generator.js.map